/**
 * 活动页面管理 store module
 */

const state = {
    tableData: []
};

const actions = {
    GET_ACTIVITY_PAGES({ commit, rootState, dispatch }) {
        commit("PRIVATE_LOADING", true, { root: true });
        rootState.$helper.request
            .get(rootState.$config.api.activity_page.list)
            .then(res => {
                commit("_updateTableData", res.data || []);
                commit("PRIVATE_LOADING", false, { root: true });
            })
            .catch(err => {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("ERROR_HANDLE", err, { root: true });
            });
    },

    ADD_ACTIVITY_PAGE({ commit, rootState, dispatch }, args) {
        commit("PRIVATE_LOADING", true, { root: true });
        rootState.$helper.request
            .post(rootState.$config.api.activity_page.add, args)
            .then(() => {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("GET_ACTIVITY_PAGES");
                dispatch("ALERT_HANDLE", { message: "添加成功！" }, { root: true });
            })
            .catch(err => {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("ERROR_HANDLE", err, { root: true });
            });
    },

    UPDATE_ACTIVITY_PAGE({ commit, rootState, dispatch }, args) {
        commit("PRIVATE_LOADING", true, { root: true });
        let url = _.replace(rootState.$config.api.activity_page.edit, '{id}', args.id);
        rootState.$helper.request
            .post(url, args)
            .then(() => {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("GET_ACTIVITY_PAGES");
                dispatch("ALERT_HANDLE", { message: "更新成功！" }, { root: true });
            })
            .catch(err => {
                commit("PRIVATE_LOADING", false, { root: true });
                dispatch("ERROR_HANDLE", err, { root: true });
            });
    }
};

const getters = {};

const mutations = {
    _updateTableData(state, data) {
        state.tableData = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/gameConfig/activityPageManager.js